import createIcon from '../../createIcon';

/**
 * @component @name KeyboardDoubleArrowLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNTkgMThMMTkgMTYuNTlMMTQuNDIgMTJMMTkgNy40MUwxNy41OSA2TDExLjU5IDEyTDE3LjU5IDE4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExIDE4TDEyLjQxIDE2LjU5TDcuODMgMTJMMTIuNDEgNy40MUwxMSA2TDUgMTJMMTEgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardDoubleArrowLeft = createIcon('KeyboardDoubleArrowLeft', [
  ['path', { d: 'M17.59 18L19 16.59L14.42 12L19 7.41L17.59 6L11.59 12L17.59 18Z', key: 'f46emv' }],
  ['path', { d: 'M11 18L12.41 16.59L7.83 12L12.41 7.41L11 6L5 12L11 18Z', key: 'qkpg1n' }],
]);

export default KeyboardDoubleArrowLeft;
